import { useSymbolsService } from 'symbols/hooks/useSymbolsService';
import { useEffect, useState } from 'react';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { useSelectAppSettings } from 'app/store/appSettings/selectors';
import { SymbolInfo } from 'symbols/symbolInfo/symbolInfoSlice';

export function useSymbol(
    symbol: string | undefined,
    symbology: SymbologyValues,
    toSymbology: SymbologyValues
) {
    const [converted, setConverted] = useState<string | undefined>(
        symbology === toSymbology ? symbol : undefined
    );
    const service = useSymbolsService();

    useEffect(() => {
        if (symbology === toSymbology) {
            setConverted(symbol);
            return;
        }

        if (symbol === undefined) {
            setConverted('');
            return;
        }

        setConverted('');
        service.convertSymbol(symbol, symbology, toSymbology).then((result) => {
            if (result) {
                setConverted(result);
            }
        });
    }, [symbol, symbology, toSymbology, service]);

    return converted;
}

export function useSymbolInUsersSymbology(
    symbol: string | undefined,
    symbology: SymbologyValues
) {
    const { symbology: usersSymbology } = useSelectAppSettings();
    return useSymbol(symbol, symbology, usersSymbology);
}

export function useSymbolInBloombergSymbology(
    symbol: string | undefined,
    symbology: SymbologyValues
) {
    return useSymbol(symbol, symbology, SymbologyValues.Bloomberg);
}

export function useSymboInfo(
    symbol: string | undefined,
    symbology: SymbologyValues
) {
    const symbolsService = useSymbolsService();
    const [symbolInfo, setSymbolInfo] = useState<SymbolInfo | undefined>(
        undefined
    );

    useEffect(() => {
        if (!symbol) {
            setSymbolInfo(undefined);
            return;
        }
        symbolsService.getSymbolInfo(symbol, symbology).then((r) => {
            setSymbolInfo(r);
        });
    }, [symbol, symbology, symbolsService]);

    return symbolInfo;
}
